import {HttpClient} from "../../service/httpClient/HttpClient";
import {LanguageHelper} from "../../util/LanguageHelper";

export class TourismService {
    constructor() {
        this.httpClient = new HttpClient();
        this.defaultLanguageCode = LanguageHelper.getLanguageCode();
    }


    addNewPlace(tourismPlaceName) {
        return this.httpClient.post(
            `languages/${this.defaultLanguageCode}/locations`,
            {
                metaData: {
                    title: tourismPlaceName
                }
            }
        )
    }

    getTourismPlaceList(page, size, title, state) {
        return this.httpClient.get(
            `locations`,
            {
                "language-code": this.defaultLanguageCode,
                size,
                page,
                title,
                published: state !== "all" ? state : null
            }
        )
    }

    getTourismPlaceDetail(languageId, id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `locations/${id}`,
                {
                    "language-code": languageId
                }
            ).then(resolve).catch(reject)
        })
    }

    updateTourismPlaceGlobalInfo(id, languageId, phoneNumber, title, hours, address, description) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `languages/${languageId}/locations/${id}`,
                {
                    phoneNumber,
                    metaData: {
                        title,
                        hours,
                        address,
                        description
                    }
                }
            ).then(resolve).catch(reject)
        })
    }

    getTourismPlaceMapAddress(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `locations/${id}/geographical`,
            ).then(resolve).catch(reject)
        })
    }

    updateTourismPlaceLocation(id, latitude, longitude) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `locations/${id}/geographical`,
                {
                    latitude, longitude
                }
            ).then(resolve).catch(reject)
        })
    }

    getTourismPlaceCategoryList(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `locations/${id}/categories`,
                {
                    "language-code": this.defaultLanguageCode
                }
            ).then(resolve).catch(reject)
        })
    }

    updateTourismPlaceCategory(id, categories) {
        const _category = []
        categories.map(item => {
            _category.push({
                id: item.id,
                slug: item.slug
            })
        })

        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `locations/${id}/categories`,
                {
                    categories: _category
                },
                {},
                {
                    "language-code": this.defaultLanguageCode
                }
            ).then(resolve).catch(reject)
        })
    }

    getTourismPlaceThumbnail(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `locations/${id}/thumbnails/url`
            ).then(resolve).catch(reject)
        })
    }

    updateTourismPlaceThumbnail(id, photoFile) {
        let data = new FormData()
        data.append('file', photoFile)


        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "multipart/form-data"
            ).patch(
                `locations/${id}/thumbnails`,
                {},
                data
            ).then(resolve).catch(reject)

        })
    }

    getTourismPlacePublished(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `locations/${id}/published`
            ).then(resolve).catch(reject)
        })
    }

    changeTourismPublishState(id, published) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `locations/${id}/published`,
                {
                    published
                }
            ).then(resolve).catch(reject)
        })
    }
}